import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import NavigationBar from './components/NavigationBar';
import Footer from './components/Footer';

import Home from './pages/Home';
import ContactUs from './pages/ContactUs';
import Service from './pages/Service';
import Careers from './pages/Careers';
import Team from './pages/Team';
import Projects from './pages/Projects';
import dynamicData from './DynamicData';


function App() {
  const services = dynamicData[0].subpages;
  return (
    <Router>
      <NavigationBar serviceslist={services}/>
      <div className="container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/service/:serviceName" element={<Service />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/team" element={<Team />} />
          <Route path="/projects" element={<Projects />} />
        
        </Routes>
      </div>
      <Footer serviceslist={services} />
    </Router>
  );
}

export default App;

// -----------------------------------------------------------------------------





